export default "__VITE_ASSET__CrX73Fix__"